import { MouseEvent } from "react";
import { Button } from "@altimateai/lego";
import { useGlobalPlaygroundActions } from "@/modules/playground";
import { DatasetsTracking } from "@/lib/tracking/datasets";

const TableAnalysisBot = ({
  tableName,
  instanceId,
}: {
  tableName: string;
  instanceId?: string;
}) => {
  const { openPlayground } = useGlobalPlaygroundActions();

  const handleClick = (e: MouseEvent) => {
    e.stopPropagation();
    DatasetsTracking.aiAnalysisStarted(tableName);
    openPlayground({
      chatbotProps: { initialMessage: "Analyse the table" },
      context: {
        tableName,
        instanceId,
      },
    });
  };

  return (
    <Button variant="secondary" onClick={handleClick}>
      Analyse the table
    </Button>
  );
};

export default TableAnalysisBot;
